import { useMediaQuery } from "./use-media-query";

// NativeTransition и Framer Motion проверяют этот флаг для instant-режима.
export function usePrefersReducedMotion(): boolean {
	return useMediaQuery("(prefers-reduced-motion: reduce)");
}
